import { atom } from "recoil";

// 当前用户登录信息
export const UserInfo = atom<any>({
  key: "UserInfo",
  default: null,
});

// 权益列表
export const RightsDict = atom<any>({
  key: "RightsDict",
  default: [],
});

// 用户搜索
export const UserSearch = atom<any>({
  key: "UserSearch",
  default: {
    visible: false,
    user_id: '',
    mobile: '',
    activeKey: '1',
    data: null,
    page: 1,
  },
})
